import { EmailHasSubfoldersBaseValueConverter } from 'General/Resources/ValueConverters/EmailHasSubfoldersBase';

export class EmailHasSubfoldersValueConverter extends EmailHasSubfoldersBaseValueConverter {
}